import { t } from '@gem/modules/i18n';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { Payload } from '../Payload';

export class StickerPayload extends Payload {
  id;
  name;
  category;
  stickerUrl;
  type;
  animationUrl;
  order;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.Sticker });

    this.id = data.id;
    this.name = data.name;
    this.stickerPackId = data.stickerPackId;
    this.stickerUrl = data.stickerUrl;
    this.graphicSize = data.graphicSize;
    this.type = data.type;
    this.animationUrl = data.animationUrl;
    this.order = data.order;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      id: this.id,
      stickerPackId: this.stickerPackId || null,
      name: this.name,
      stickerUrl: this.stickerUrl,
      type: this.type,
      animationUrl: this.animationUrl || null,
      graphicSize: this.graphicSize,
      order: this.order,
    };
  }

  get text() {
    return t('message_desctription_sticker');
  }

  get typeDescription() {
    return t('message_desctription_sticker');
  }
}
